import { en } from './en';
import { hi } from './hi';
import { rj } from './rajasthani';

export const translations = {
  en,
  hi,
  rj
};

